import {testIdProps} from '@github-ui/test-id-props'
import {VisuallyHidden} from '@github-ui/visually-hidden'
import {Box, CounterLabel} from '@primer/react'

type FilterCounterLabelProps = {
  /**
   * The number of results that match the filter and should be shown in the label.
   * If null or undefined, the label will not be shown.
   */
  filterCount: number | null | undefined

  /**
   * Whether or not to explicitly hide the counter label (even if there are filtered results)
   */
  hideCounterLabel: boolean

  /**
   * Whether or not there are more items that match the filter but are not shown in the list,
   * i.e. have not yet been sent down to the client.
   */
  hasMoreItems?: boolean
}

const containerSx = {lineHeight: 0}
export function FilterCounterLabel({filterCount, hideCounterLabel, hasMoreItems}: FilterCounterLabelProps) {
  return !hideCounterLabel && typeof filterCount === 'number' ? (
    <Box sx={containerSx} aria-live="polite" aria-atomic>
      <CounterLabel {...testIdProps('filter-results-count')}>
        {filterCount}
        {hasMoreItems ? '+' : null}
      </CounterLabel>
      <VisuallyHidden> {filterCount === 1 ? 'matching item' : 'matching items'}</VisuallyHidden>
    </Box>
  ) : null
}

try{ FilterCounterLabel.displayName ||= 'FilterCounterLabel' } catch {}